import { Outlet } from "react-router-dom";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { AppLogFab } from "@/components/logs/AppLogFab";

export function AppLayout() {
  return (
    <SidebarProvider defaultOpen={true}>
      <AppSidebar />
      <SidebarInset>
        <Outlet />
      </SidebarInset>
      {/* Panel logów montowany TUTAJ, a nie w App.tsx — AppLayout siedzi
          wewnątrz ProtectedRoute + TwoFactorGate, więc przycisk dziedziczy
          obie bramki i znika z ekranu logowania. Logi zawierają nazwy domen,
          tytuły artykułów i treści błędów — nie ma powodu, żeby ktokolwiek
          niezalogowany mógł je otworzyć na współdzielonym komputerze. */}
      <AppLogFab />
    </SidebarProvider>
  );
}
